<template>
  <v-dialog v-model="isOpen" scrollable max-width="950px" persistent>
    <v-card tile>
      <v-toolbar flat dark color="rgb(51, 97, 137)">
        <v-toolbar-title>
          <v-icon left>mdi-access-point</v-icon>
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.editAddLive'
            )
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn icon dark @click="clearData" v-on="on">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span class="subtitle-1">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.close'
            )
          }}</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text class="pt-3">
        <v-form ref="form" v-model="valid" v-on:submit.prevent="validate">
          <v-row>
            <v-col cols="12" :lg="12" :md="12" :sm="12">
              <p class="title">
                {{ $vuetify.lang.t('$vuetify.liveName') }}
                <span class="red--text">*</span>
              </p>
              <v-text-field
                v-model="live.title"
                :rules="nameRules"
                outlined
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" :lg="12" :md="12" :sm="12">
              <p class="title">
                {{ $vuetify.lang.t('$vuetify.liveDescription') }}
              </p>
              <v-textarea
                counter
                v-model="live.description"
                outlined
                height="180"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" :lg="6" :md="6" :sm="6">
              <p class="mb-2 body-1 font-weight-medium">
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.startDate'
                  )
                }}
              </p>
              <v-card class="px-3" color="grey lighten-5" elevation="0">
                <v-row>
                  <v-col cols="5">
                    <p class="ml-8 mb-2 grey--text">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.date'
                        )
                      }}
                    </p>
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="date"
                          label
                          prepend-icon="event"
                          background-color="white"
                          persistent-hint
                          readonly
                          outlined
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="date"
                        no-title
                        :min="nowDate"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false">{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.liveStep.addLiveDialog.cancel'
                          )
                        }}</v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu.save(date)"
                          >{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.liveStep.addLiveDialog.ok'
                            )
                          }}</v-btn
                        >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="3" class="pr-md-0">
                    <p class="mb-2 grey--text">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.hh'
                        )
                      }}
                    </p>
                    <v-autocomplete
                      v-model="start_time_hour"
                      :items="start_hour"
                      background-color="white"
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="1" class="position-relative">
                    <div class="colon">
                      <p class="mb-0 font-weight-bold">:</p>
                    </div>
                  </v-col>
                  <v-col cols="3" class="pl-md-0">
                    <p class="mb-2 grey--text">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.mm'
                        )
                      }}
                    </p>
                    <v-autocomplete
                      v-model="start_time_minute"
                      :items="start_minute"
                      outlined
                      background-color="white"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card>
              <!--<v-row>
                        <v-col>
                          <p class="mb-2 body-1 font-weight-medium">Live Type</p>
                          <v-radio-group class="mt-0" v-model="live.source" :mandatory="false">
                            <v-radio label="Live by yourself" value="stream"></v-radio>
                            <v-radio label="Live by video" value="vod"></v-radio>
                          </v-radio-group>
                          <v-file-input
                            v-model="file_vedio"
                            color="deep-purple accent-4"
                            counter
                            placeholder="เลือกไฟล์วิดีโอที่ต้องการ"
                            outlined
                            :show-size="1000"
                            accept=".mp4"
                            prepend-icon="mdi-video"
                            @change="onFileVideoChange"
                            :disabled="live.source=='stream'"
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip
                                v-if="index < 2"
                                color="deep-purple accent-4"
                                dark
                                label
                                small
                              >{{ text }}</v-chip>

                              <span
                                v-else-if="index === 2"
                                class="overline grey--text text--darken-3 mx-2"
                              >+{{ files.length - 2 }} File(s)</span>
                            </template>
                          </v-file-input>
                        </v-col>
                      </v-row>-->
            </v-col>
            <v-col cols="6" :lg="6" :md="6" :sm="6">
              <p class="mb-2 body-1 font-weight-medium">
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.endDate'
                  )
                }}
              </p>
              <v-card class="px-3" color="grey lighten-5" elevation="0">
                <v-row>
                  <v-col cols="5">
                    <p class="ml-8 mb-2 grey--text">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.date'
                        )
                      }}
                    </p>
                    <v-menu
                      ref="menu_enddate"
                      v-model="menu_enddate"
                      :close-on-content-click="false"
                      :return-value.sync="endDate"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                      background-color="white"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="endDate"
                          label
                          prepend-icon="event"
                          persistent-hint
                          background-color="white"
                          readonly
                          outlined
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="endDate"
                        no-title
                        :min="date"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="menu_enddate = false"
                          >{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.liveStep.addLiveDialog.cancel'
                            )
                          }}</v-btn
                        >
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu_enddate.save(endDate)"
                          >{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.liveStep.addLiveDialog.ok'
                            )
                          }}</v-btn
                        >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="3" class="pr-md-0">
                    <p class="mb-2 grey--text">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.hh'
                        )
                      }}
                    </p>
                    <v-autocomplete
                      v-model="end_time_hour"
                      :items="start_hour"
                      background-color="white"
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="1" class="position-relative">
                    <div class="colon">
                      <p class="mb-0 font-weight-bold">:</p>
                    </div>
                  </v-col>
                  <v-col cols="3" class="pl-md-0">
                    <p class="mb-2 grey--text">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.mm'
                        )
                      }}
                    </p>
                    <v-autocomplete
                      v-model="end_time_minute"
                      :items="start_minute"
                      outlined
                      background-color="white"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              elevation="0"
              class="
                px-9
                ma-2
                subtitle-2
                button-secondary
                font-weight-light
                text-capitalize
              "
              outlined
              @click="closeDialog"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.liveStep.addLiveDialog.cancel'
                )
              }}</v-btn
            >
            <v-btn
              elevation="0"
              class="
                px-10
                ma-2
                subtitle-2
                text-capitalize
                font-weight-light
                button-primary
              "
              :disabled="!valid || !checkTime"
              @click="validate"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.liveStep.addLiveDialog.save'
                )
              }}</v-btn
            >
          </v-card-actions>
        </v-form>
        <v-dialog v-model="fail_dialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.liveStep.addLiveDialog.failed'
              )
            }}</v-card-title>
            <v-card-text>{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.liveStep.addLiveDialog.failedToEdit'
              )
            }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="fail_dialog = false">{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.liveStep.addLiveDialog.close'
                )
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogWarning" persistent max-width="450">
          <v-card>
            <v-card-title class="headline"
              >ไม่สามารถบันทึกข้อมูลได้</v-card-title
            >
            <v-card-text v-if="this.startTime >= this.endTime"
              >&nbsp;-&nbsp;กรุณาตรวจสอบวัน-เวลาที่เริ่มไลฟ์
              และวัน-เวลาสิ้นสุดการไลฟ์</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="0"
                class="mb-0 body-2 text-primary text-capitalize"
                color="white"
                @click="dialogWarning = false"
                >ตกลง</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { insertLive, getLiveDetail, updateLive } from '@/service/course/livev2';
export default {
  props: {
    isOpen: {
      type: Boolean,
    },
    closeDialog: {
      type: Function,
    },
    idcourse: {
      type: String,
    },
    liveId: {
      type: String,
    },
  },

  watch: {
    isOpen: async function (newValue) {
      if (newValue) {
        if (this.liveId) {
          let result = await getLiveDetail(this.liveId);
          this.live = {
            title: result.title,
            description: result.description,
            source: result.source ? result.source : 'stream',
            pdfs: result.pdfs,
            images: result.images,
            urls: result.urls,
          };
          // this.date = new Date(result.startTime).toISOString().substr(0, 10);

          let y = new Date(result.startTime).getFullYear();
          let m = new Date(result.startTime).getMonth() + 1;
          let d = new Date(result.startTime).getDate();
          this.date =
            y +
            '-' +
            m.toString().padStart(2, '0') +
            '-' +
            d.toString().padStart(2, '0');

          // this.endDate = new Date(result.endTime).toISOString().substr(0, 10);
          y = new Date(result.endTime).getFullYear();
          m = new Date(result.endTime).getMonth() + 1;
          d = new Date(result.endTime).getDate();
          this.endDate =
            y +
            '-' +
            m.toString().padStart(2, '0') +
            '-' +
            d.toString().padStart(2, '0');

          this.start_time_hour = new Date(result.startTime)
            .toString()
            .substr(16, 2);
          this.start_time_minute = new Date(result.startTime)
            .toString()
            .substr(19, 2);
          this.end_time_hour = new Date(result.endTime)
            .toString()
            .substr(16, 2);
          this.end_time_minute = new Date(result.endTime)
            .toString()
            .substr(19, 2);
        } else {
          (this.live = {
            title: '',
            description: '',
            startTime: '',
            endTime: '',
            source: 'stream',
            idcourse: '',
            pdfs: null,
            images: null,
            urls: null,
          }),
            (this.date = new Date().toISOString().substr(0, 10));
          this.endDate = new Date().toISOString().substr(0, 10);
          this.start_time_hour = '00';
          this.start_time_minute = '00';
          this.end_time_hour = '00';
          this.end_time_minute = '00';
          this.main_tabs = 'detail';
          this.$refs.form.resetValidation();
        }
      }
    },
  },
  data: () => ({
    valid: true,
    name: '',
    date: new Date().toISOString().substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    nowDate: new Date().toISOString().slice(0, 10),

    menu: false,
    modal: false,
    menu_enddate: false,

    start_time_hour: '20',
    start_time_minute: '00',
    end_time_hour: '21',
    end_time_minute: '00',
    start_hour: [
      '00',
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
      '21',
      '22',
      '23',
    ],
    start_minute: ['00', '10', '20', '30', '40', '50'],
    end_hour: [],
    end_minute: [],
    live: {
      title: '',
      description: '',
      startTime: 0,
      endTime: 0,
      source: 'stream',
      idcourse: '',
      pdfs: null,
      images: null,
      urls: null,
    },

    startTime: 0,
    endTime: 0,
    //modal
    dialogWarning: false,
    dialog: false,
    fail_dialog: false,

    //tabs
    main_tabs: 'detail',
  }),

  computed: {
    nameRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.liveStep.addLiveDialog.nameRules'
          ),
      ];
    },
    descriptionRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.liveStep.addLiveDialog.descriptionRules'
          ),
      ];
    },
    checkTime() {
      let dt_start =
        this.date + ',' + this.start_time_hour + ':' + this.start_time_minute;
      let dt_end =
        this.endDate + ',' + this.end_time_hour + ':' + this.end_time_minute;
      let startTime = new Date(dt_start);
      let endTime = new Date(dt_end);
      if (startTime >= endTime) {
        return false;
      } else return true;
    },
  },

  methods: {
    async validate() {
      let dt_start =
        this.date + ',' + this.start_time_hour + ':' + this.start_time_minute;
      let dt_end =
        this.endDate + ',' + this.end_time_hour + ':' + this.end_time_minute;
      this.startTime = new Date(dt_start);
      this.endTime = new Date(dt_end);
      if (this.startTime >= this.endTime) {
        // this.valid = false;
        this.dialogWarning = true;
      } else {
        if (this.$refs.form.validate()) {
          let live = {
            title: this.live.title,
            description: this.live.description,
            course: this.idcourse,
            startTime: this.startTime.getTime(),
            endTime: this.endTime.getTime(),
            // source: this.source,
            // pdfs: null,
            // images: null,
            // urls: null,
          };
          if (this.liveId) {
            live = {
              title: this.live.title,
              description: this.live.description,
              course: this.idcourse,
              startTime: this.startTime.getTime(),
              endTime: this.endTime.getTime(),
              source: this.source,
              pdfs: this.live.pdfs,
              images: this.live.images,
              urls: this.live.urls,
            };
            let result = await updateLive(this.liveId, live);
            if (result) {
              // this.main_tabs = 1;
              this.closeDialog();
            } else {
              this.fail_dialog = false;
            }
          } else {
            let result = await insertLive(live);
            if (result) {
              // this.liveId = result._id;
              // this.main_tabs = 'media';
              this.closeDialog();
            } else {
              this.fail_dialog = false;
            }
          }
          // this.closeDialog();
        } else return;
      }
    },
    initialize() {
      this.live = {
        title: '',
        description: '',
        startTime: '',
        endTime: '',
        source: 'stream',
        idcourse: '',
        pdfs: null,
        images: null,
        urls: null,
      };
      this.date = new Date().toISOString().substr(0, 10);
      this.endDate = new Date().toISOString().substr(0, 10);
      this.start_time_hour = new Date().toISOString().substr(11, 2);
      this.start_time_minute = new Date().toISOString().substr(14, 2);
      this.end_time_hour = new Date().toISOString().substr(11, 2);
      this.end_time_minute = new Date().toISOString().substr(14, 2);
      this.main_tabs = 'detail';
      // this.valid = false;
      // this.$refs.form.resetValidation();
    },
    openMediaDialog() {
      this.dialog = true;
    },
    closeMediaDialog() {
      this.dialog = false;
    },
    clearData() {
      this.main_tabs = 'detail';
      this.live = {
        title: '',
        description: '',
        startTime: '',
        endTime: '',
        source: 'stream',
        idcourse: '',
        pdfs: null,
        images: null,
        urls: null,
      };
      this.date = new Date().toISOString().substr(0, 10);
      this.endDate = new Date().toISOString().substr(0, 10);
      this.$refs.form.resetValidation();
      //  this.initialize();
      this.closeDialog();
    },
  },
};
</script>

<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
.border {
  border: 1px solid rgb(195, 195, 195) !important;
}
.position-relative {
  position: relative;
}
.colon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.v-tabs--grow > .v-tabs-bar .v-tab {
  flex: none;
}
.v-tab--active {
  background: #fff !important;
  color: #009bde;
}

.tab-live {
  border-radius: 10px 10px 0 0;
  background: #fafafa;
  border: 1px solid #e7e7e7;
  border-bottom: 0;
  box-shadow: 0;
}
.uppercast-unset {
  text-transform: unset;
}
</style>
<style lang="scss">
.v-text-field--outlined .v-input__prepend-outer {
  margin-top: 9px !important;
}
.v-input__append-inner {
  margin-top: 9px !important;
}
</style>
